export const SoftwaresMapper = {
  hydrate: (softwares) => {
    const data = {
      softwaresList:
        (typeof softwares === "object" &&
          softwares.map((element) => ({
            label: element.node?.name,
            value: element?.node?.id,
          }))) ||
        [],
    };

    return data;
  },
  hydrateSingle: (software) => {
    const data = {
      label: software.name,
      value: software.id,
    };
    return data;
  },
  hydrateId: (software) => {
    return software.id;
  },
};
